export type PrimaryShortcutModifier = "Cmd" | "Ctrl";

function getNavigatorPlatform(): string {
  if (typeof navigator === "undefined") {
    return "";
  }

  return navigator.platform || "";
}

export function isMacPlatform(platform = getNavigatorPlatform()): boolean {
  return /mac|iphone|ipad|ipod/i.test(platform);
}

export function getPrimaryShortcutModifier(
  platform?: string
): PrimaryShortcutModifier {
  return isMacPlatform(platform) ? "Cmd" : "Ctrl";
}

export function formatPrimaryShortcut(
  key: string,
  options: { platform?: string; shift?: boolean } = {}
): string {
  return [
    getPrimaryShortcutModifier(options.platform),
    options.shift ? "Shift" : undefined,
    key,
  ]
    .filter(Boolean)
    .join("+");
}
